import { render, staticRenderFns } from "./CreateCustomerBespokePricePopUp.vue?vue&type=template&id=005af37c&scoped=true&"
import script from "./CreateCustomerBespokePricePopUp.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerBespokePricePopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomerBespokePricePopUp.vue?vue&type=style&index=0&id=005af37c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005af37c",
  null
  
)

export default component.exports